<template>
    <div class="company-Main">
        <p class="current">当前位置：<span>直播详情</span></p>
        <div class="company-info trainTitle">
             <p class="companyName titleP">{{ companyInfo.name }}</p>
            <p class="descri">{{ companyInfo.description }}</p>
            <img :src="companyInfo.firstFile.FileUrl" alt="" class="companyImg" style="margin-top: 20px">
           
            <div class="company-detail">
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="附件" name="1">
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item title="详细介绍" name="1">
                        <div v-html="companyInfo.intro" class="introinfo"></div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>
<script>
export default({
    data(){
        return {
            companyInfo: [],
            activeNames: ['1','2'],
            companyproduct: []
        }
    },
    methods: {
        handleChange(val) {
            console.log(val);
        },
       
    },
    mounted(){
        let data = {
            id: this.$route.query.key
        }
        console.log("第一步");
        
        this.$store.dispatch('video/detail',data)
            .then(res => {
                if(res.ok){
                    this.$nextTick(() => {
                        this.companyInfo = res.data
                    })

                }else{
                    if(res.code == -1){
                        this.$router.push({
                            path: '/login'
                        })
                    }
                }
            })
        
    }
})
</script>

<style>
@import '../../css/info.css'
</style>
